import { Injectable } from '@angular/core';
import { EOI_IDLE_TIMEOUT_CONFIG } from '../shared/global-constants';
import { IdleTimeoutConfiguration } from '../shared/model/idle-timeout-configuration';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  // ui base path
  public deployPath = '';

  // api urls and identifiers
  public mhsApiEndpoint = '';
  public alternateMhsApiEndpoint = '';
  public contractsApiEndpoint = '';
  public alternateContractsApiEndpoint = '';
  public apiSubscriptionId = '';
  public sreAPPIKey = '';
  public sreAPPIConnectionString = '';
  public environment = '';
  public nmDomainName : string = '';

  // timeout of user session
  public idleTimeoutConfig: IdleTimeoutConfiguration = EOI_IDLE_TIMEOUT_CONFIG;

  // Google Tag Manager code
  public googleTagManagerCode = '';

  // Whether or not to enable debug mode
  public enableDebug = false;

  constructor() {}
}
